export const numSampleFiles = {
    AintroPrompt: 2,
    BintroPrompt: 1,
    ApromptMore: 8,
    BpromptMore: 8,
    ApromptMoreTwo: 8,
    BpromptMoreTwo: 8,
    AproposeLoopback: 5,
    BproposeLoopback: 5,
    AtoContinueLoop: 2,
    BtoContinueLoop: 2,
    AsorryDidntGetThat: 2,
    BsorryDidntGetThat: 2,
    ApleaseAnswerYesOrNo: 1,
    BpleaseAnswerYesOrNo: 1,
    AtoPlayback: 3,
    BtoPlayback: 3,
    BthankYouForSharing: 2,
};
